import ContentSpinner from "./content-spinner";

export default ContentSpinner;
